import { EKeyboardKeys } from "../../../../../constants/KeyboardKeys";
import { iContact } from "../../../../../interfaces/Contact";
import { BsSearch, BsPlus } from "react-icons/bs";
import { Contact } from "./Contact";
import { useEffect } from "react";

interface Props {
    onContactClick: (id: string) => void;
    onAddContactClick: () => void;
    contacts: iContact[];
}

export function ContactList(props: Props) {
    useEffect(() => {
        document.addEventListener("keydown", handleKeyDown, false);

        return () => {
            document.removeEventListener("keydown", handleKeyDown, false);
        };
    }, []);

    const handleKeyDown = async (e: KeyboardEvent) => {
        switch (e.code) {
            case EKeyboardKeys.ENTER:
                handleItemClick();
                break;
            case EKeyboardKeys.ENTER_NUMPAD:
                handleItemClick();
                break;
            case EKeyboardKeys.SPACE:
                handleItemClick();
                break;
            case EKeyboardKeys.ARROW_UP:
                handleArrowUp();
                break;
            case EKeyboardKeys.ARROW_DOWN:
                handleArrowDown();
                break;
            case EKeyboardKeys.TAB:
                e.preventDefault();
                handleArrowDown();
                break;
            default:
                break;
        }
    };

    const handleItemClick = () => {
        const focusedElt = document.activeElement as HTMLElement;
        if (props.contacts.find(ct => ct.id === focusedElt?.id) !== undefined) focusedElt.click();
    };

    const handleArrowUp = async () => {
        if (props.contacts.length === 0) return;

        if (props.contacts.length === 1) {
            const nextElt = document.getElementById(props.contacts[0].id);
            nextElt?.focus();
            return;
        }

        const focusedElt = document.activeElement as HTMLElement;
        const activeEltIndex = props.contacts.findIndex(ct => ct.id === focusedElt?.id);
        if (activeEltIndex === -1 || activeEltIndex === 0) {
            const nextPos = props.contacts.length - 1;
            const nextElt = document.getElementById(props.contacts[nextPos].id);
            nextElt?.focus();
            return;
        }

        const nextPos = activeEltIndex - 1;
        const nextElt = document.getElementById(props.contacts[nextPos].id);
        nextElt?.focus();
        return;
    };

    const handleArrowDown = async () => {
        if (props.contacts.length === 0) return;

        if (props.contacts.length === 1) {
            const nextElt = document.getElementById(props.contacts[0].id);
            nextElt?.focus();
            return;
        }

        const focusedElt = document.activeElement as HTMLElement;
        const activeEltIndex = props.contacts.findIndex(ct => ct.id === focusedElt?.id);
        if (activeEltIndex === -1 || activeEltIndex === props.contacts.length - 1) {
            const nextPos = 0;
            const nextElt = document.getElementById(props.contacts[nextPos].id);
            nextElt?.focus();
            return;
        }

        const nextPos = activeEltIndex + 1;
        const nextElt = document.getElementById(props.contacts[nextPos].id);
        nextElt?.focus();
        return;
    };

    return (
        <ul
            className="contact-list-container"
            id="autocomplete-list"
            role="listbox"
        >
            <li>
                <button
                    className="g-btn-default"
                    onClick={props.onAddContactClick}
                >
                    <BsPlus></BsPlus>
                    <span style={{ fontSize: "9pt" }}>Add new contact</span>
                </button>
            </li>
            <li>
                <ul className="contact-list">
                    {props.contacts.length > 0 ? (
                        props.contacts.map(ctProps => (
                            <Contact
                                {...ctProps}
                                onClick={props.onContactClick}
                            />
                        ))
                    ) : (
                        <li>No Contacts</li>
                    )}
                </ul>
            </li>
        </ul>
    );
}
